import type { MaybeRef } from "vue"
import type { ServerResponseV1 } from "@/http"
import { useQuery } from "@tanstack/vue-query"
import { toValue } from "vue"
import { v1 } from "@/axios"
import { EventTemplate } from "@/models"

export async function getEventTheme(eventVaultId: number) {
  const response = await v1.get<ServerResponseV1<EventTemplate>>(`/events/${eventVaultId}/theme`)

  return EventTemplate.fromResponseV1(response.data.data)
}

export const GET_EVENT_THEME = "getEventTheme"

export function useGetEventTheme(eventVaultId?: MaybeRef<number | undefined>) {
  return useQuery({
    queryKey: [GET_EVENT_THEME, eventVaultId],
    queryFn: () => getEventTheme(toValue(eventVaultId)!),
    enabled: !!toValue(eventVaultId),
  })
}
